/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class IconOne extends React.Component {
  render() {
    return (
      <svg viewBox="0 0 404 404">
        <path
          fill="none"
          stroke="#827ddc"
          strokeWidth="10"
          d="M276.8 125.6C264.8 52 235.2.8 200.8.8s-64 51.2-76 125.6C49.6 137.6 0 167.2 0 201.6s51.2 64 125.6 76c12 74.4 40.8 125.6 76 125.6 9.6 0 19.2-4 27.2-10.4 3.2-3.2 4-8 .8-11.2s-8-4-11.2-.8c-4.8 4-10.4 6.4-16.8 7.2-23.2 0-48-41.6-59.2-107.2 19.2 2.4 39.2 3.2 59.2 3.2s39.2-.8 59.2-3.2c-1.6 11.2-4 22.4-7.2 33.6l-10.4-16c-2.4-4-7.2-4.8-11.2-2.4-3.2 2.4-4.8 7.2-2.4 10.4l19.2 31.2.8.8.8.8.8.8.8.8 1.6.8h3.2c.8 0 2.4 0 3.2-.8l36.8-17.6c4-1.6 6.4-6.4 4.8-10.4s-6.4-6.4-10.4-4.8c0 0-.8 0-.8.8l-20 9.6c3.2-12.8 6.4-26.4 8-39.2 74.4-12 125.6-41.6 125.6-76s-52.8-65.6-127.2-77.6zM122.4 260.8C57.6 249.6 16 224.8 16 201.6c0-24.8 44-48 107.2-59.2-4.8 39.2-4.8 79.2-.8 118.4zm140 2.4c-20.8 2.4-40.8 4-61.6 4s-40.8-1.6-61.6-4c-5.6-40.8-5.6-82.4 0-123.2l10.4-.8c4.8-.8 8-4.8 7.2-8.8s-4.8-8-8.8-7.2l-5.6.8c10.4-65.6 35.2-107.2 58.4-107.2s48 41.6 59.2 107.2c-10.4-.8-20-2.4-31.2-2.4l12-12.8c3.2-3.2 3.2-8 0-11.2s-8-3.2-11.2 0L203.2 124l-.8.8s-.8.8-.8 1.6v6.4c0 .8.8.8.8 1.6 0 0 0 .8.8.8l26.4 32c2.4 3.2 7.2 4 11.2 1.6 3.2-2.4 4-7.2 1.6-11.2l-.8-.8-15.2-19.2c12.8.8 24.8 1.6 36 3.2 2.4 20.8 4 40.8 4 61.6 0 20-1.6 40-4 60.8zm16-2.4c2.4-19.2 3.2-39.2 3.2-59.2s-.8-39.2-3.2-59.2c66.4 11.2 107.2 36.8 107.2 59.2s-41.6 48-107.2 59.2z" 
        />
      </svg>
    );
  }
}

export default IconOne;



// WEBPACK FOOTER //
// ./src/routes/home/img/icons/IconOne.js